import React, { createContext, useContext, useEffect, useState } from 'react';
import TokenManagerService from 'App/services/TokenManagerService';
import PropTypes from 'prop-types';

const context = createContext(null);

const { Provider } = context;

const propTypes = {
    children: PropTypes.node.isRequired,
};

const defaultProps = {};

function AuthTokenProvider({ children }) {
    const [tokens, setTokens] = useState({
        access: TokenManagerService.getAccessToken(),
    });

    useEffect(() => {
        return TokenManagerService.subscribe(setTokens);
    }, []);

    return <Provider value={tokens}>{children}</Provider>;
}

function useAuthTokens() {
    return useContext(context);
}

AuthTokenProvider.propTypes = propTypes;
AuthTokenProvider.defaultProps = defaultProps;

export { AuthTokenProvider, context, useAuthTokens };
